import { render, staticRenderFns } from "./recently-bought-loader.vue?vue&type=template&id=682ab992&scoped=true"
import script from "./recently-bought-loader.vue?vue&type=script&lang=js"
export * from "./recently-bought-loader.vue?vue&type=script&lang=js"
import style0 from "./recently-bought-loader.vue?vue&type=style&index=0&id=682ab992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682ab992",
  null
  
)

export default component.exports